import { rawBaseQuery } from "../features/api/Api";
import { logout, tokenReceived } from "../features/auth/AuthSlice";

async function unAuthorizedHandler(
  args: any,
  api: any,
  extraOptions: any,
  result: any
) {
  // unAuthorized Forbidden
  if (result.error && result.error.status === 401) {
    // try to get a new token
    const refreshResult: any = await rawBaseQuery(
      "/fixity/refreshToken",
      api,
      extraOptions
    );
    if (refreshResult.data) {
      // store the new token
      api.dispatch(tokenReceived(refreshResult.data));
      // retry the initial query
      result = await rawBaseQuery(args, api, extraOptions);
    } else {
      api.dispatch(logout());
    }
  }
  return result;
}

export default unAuthorizedHandler;
